/**
 * /advertisers/approval — advertiser-side conversion review (scrub) page.
 *
 * Declares a TanStack Router route and renders `AdvertiserApprovalPage`.
 */
import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserApprovalPage } from "@/features/advertiser-approval/AdvertiserApprovalPage";

export const advertisersApprovalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/approval",
	component: AdvertisersApprovalRoute,
});

export default advertisersApprovalRoute;

export function AdvertisersApprovalRoute() {
	return (
		<div className="mx-auto flex w-full max-w-6xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<AdvertiserApprovalPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Advertisers</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Approval</li>
			</ol>
		</nav>
	);
}
